<section class="funfact-one login">
  <img src="/assets/images/shapes/testi-shape-1-1.png" class="testimonials-one__background-image" alt="Awesome Image" />
<div class="row justify-content-center">
  <div class="modal-content col-lg-4 col-md-12">
                
      <div class="modal-header text-center">
        <h4 class="modal-title w-100 font-weight-bold" translate>Loguearse</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    <form [formGroup]="loginForm" class="loginForm"> 
      <div class="modal-body mx-3">
        <div *ngIf="showError" class="alert alert-danger">
                    <div >
                   {{response.AlertMessage}}
                  </div>
                </div>
        <div class="md-form mb-4">
          <i class="fas fa-envelope prefix grey-text login-icon"></i>
          <input type="email" id="defaultForm-email" class="form-control validate" formControlName="email">
          <label data-error="wrong" data-success="right" for="defaultForm-email" translate>Correo electronico</label>
        <div *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)" class="alert alert-danger">
                    <div  translate *ngIf="loginForm.controls['email'].errors.required">Correo electronico es requerido.</div>
                </div>
        </div>
        <div class="md-form mb-4">
          <i class="fas fa-lock prefix grey-text login-icon"></i>
          <input type="password" id="defaultForm-pass" class="form-control validate" formControlName="password">
          <label data-error="wrong" data-success="right" for="defaultForm-pass" translate>Contraseña</label>
        <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)" class="alert alert-danger">
                    <div  translate *ngIf="loginForm.controls['password'].errors.required">Contraseña es requerido.</div>
                </div>
        </div>
      </div>
    </form>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-default login-btn" (click)="login()" [disabled]="loginForm.invalid" translate>Iniciar Sesión</button>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <a class="password-reset" [routerLink]="['/password-reset']" translate>¿Olvido su contraseña?</a>
      </div>
    </div>
  </div>
</section><!-- /.funfact-one -->